import { Button, ButtonVariant } from "@blueprintjs/core"
import { useState } from "react"
import { GRADIENT_DISTINATION } from "src/libs/utilities/colors"


const GradientDistination = (props: any) : JSX.Element => {
    const getDistination = (distination: GRADIENT_DISTINATION) : string => {
        switch( distination ) {
            case GRADIENT_DISTINATION.TO_LEFT:
                return ("left")  
            case GRADIENT_DISTINATION.TO_RIGHT:
                return ("right" ) 
            case GRADIENT_DISTINATION.TO_TOP:
                return ("up" ) 
            case GRADIENT_DISTINATION.TO_BOTTOM:
            default:
                return("down")  
        }
    }
    const [distination, setDistination] = useState<string>(  getDistination( props.distination ) )
    const onClick = () => {
        const next = (): any => ({
            left: "up",
            up: "right",
            right: "down",
            down: "left", 
        })
        setDistination( next()[distination].toString() )
        if(props.onClick) {
            props.onClick( `to_${ next()[distination].toString() }` )
        }
    }
    
    return <Button variant={ButtonVariant.MINIMAL} className='p-2 ' onClick={onClick}>
        <i className={`fas fa-arrow-${distination}`}></i>
    </Button>
}

export default GradientDistination